import { useTranslation } from 'react-i18next';
import {
  StructureGrayButton,
  StructureNavigation
} from '../../../MyTeamBackofficeStyled';
import { Position, StructureType } from '../../../myTeamBackOffice.constants';
import {
  BackOnTopButton,
  GoBottomButton,
  GoLeftDownArrowButton,
  GoRightDownArrowButton,
  GoUpArrowButton
} from '../common/StructureNav';

import { motion } from 'framer-motion';
import { useAppSelector } from '../../../../../app/hooks';

const StructureNav = ({ selectTab }) => {
  const { t } = useTranslation('myTeam');
  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  return (
    <motion.div>
      <StructureNavigation>
        <GoUpArrowButton />
        <GoLeftDownArrowButton />
        <BackOnTopButton />
        <GoBottomButton
          position={Position.L}
          label={t('go_bottom_left')}
          isDisabled={false}
          structureType={StructureType.TRADING}
        />
        {!isCanadaRestrictedUser && (
          <StructureGrayButton
            orangeGradient
            onClick={() => selectTab('structure')}>
            {t('add_new_member')}
          </StructureGrayButton>
        )}

        <GoBottomButton
          position={Position.R}
          label={t('go_bottom_right')}
          isDisabled={false}
          structureType={StructureType.TRADING}
        />

        <GoUpArrowButton />
        <GoRightDownArrowButton />
      </StructureNavigation>
    </motion.div>
  );
};

export default StructureNav;
